var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 7.5C15.418 7.5 15 7.91797 15 8.40234V10C15 12.9199 12.4805 15.2695 9.5 14.9766C6.90625 14.7227 5 12.3867 5 9.77344V8.40234C5 7.91797 4.58008 7.5 4.0625 7.5C3.54492 7.5 3.125 7.91797 3.125 8.40234V9.6582C3.125 13.1594 5.625 16.2832 9.0625 16.7559V18.125H7.15234C6.66797 18.125 6.25 18.543 6.25 19.0273C6.25 19.5117 6.66797 20 7.15234 20H12.7773C13.332 20 13.75 19.582 13.75 19.0625C13.75 18.543 13.332 18.125 12.8125 18.125H10.9375V16.8059C14.2891 16.3477 16.875 13.4727 16.875 10V8.40234C16.875 7.91797 16.457 7.5 15.9375 7.5ZM10 13.75C12.0703 13.75 13.75 12.0703 13.75 10V3.75C13.75 1.71484 12.0703 0 10 0C7.92969 0 6.25 1.67969 6.25 3.75V10C6.25 12.0703 7.92969 13.75 10 13.75ZM8.125 3.75C8.125 2.71484 8.96484 1.875 10 1.875C11.0352 1.875 11.875 2.71484 11.875 3.75V10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10V3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.e8cf78296209a0402d5f5cb111cd0405.svg";
export { ForwardRef as ReactComponent };